var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sabc_tier_sports_area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12"},[_c('div',{staticClass:"sabc_tier_sports_title_tabs"})])])])])
}]

export { render, staticRenderFns }